/**
 * Updates or creates a meta tag in the document head
 */
export const updateMetaTag = (
  attribute: "name" | "property",
  attributeValue: string,
  content: string
) => {
  let metaTag = document.querySelector(`meta[${attribute}="${attributeValue}"]`);
  
  if (metaTag) {
    metaTag.setAttribute("content", content);
  } else {
    metaTag = document.createElement("meta");
    metaTag.setAttribute(attribute, attributeValue);
    metaTag.setAttribute("content", content);
    document.head.appendChild(metaTag);
  }
};
